{
  "add-new-contact": "Agregar nuevo contacto",
  "hoa": "HOA",
  "reference": "# Referencia",
  "routing": "Enrutamiento #",
  "account": "Cuenta #",
  "no-items": "Aún no hay elementos",
  "go-to-created-contact":"Ir al usuario creado",
  "addEmailModalTitle": "Agregar Correo Electrónico",
  "emailAddressLabel": "Dirección de Correo Electrónico",
  "kindLabel": "Tipo",
  "loginEmailHelperText": "El correo electrónico de tipo Login debe agregarse en la sección de acceso.",
  "managePermissionsModalTitle": "Administrar Permisos",
  "addButton": "Agregar",
  "permissionElementLabel": "Elemento de Permiso",
  "accessInformationLabel": "Acceso a Información",
  "updateInformationLabel": "Actualizar Información",
  "roleLabel": "Rol",
  "addAccountModalTitle": "Agregar Cuenta",
  "accountNumberLabel": "Número de Cuenta",
  "bankLabel": "Banco",
  "bankAddressLabel": "Dirección del Banco",
  "countryLabel": "País",
  "accountNameLabel": "Nombre de la Cuenta",
  "routingNumberLabel": "Número de Enrutamiento",
  "addLicenseModalTitle": "Agregar Licencia",
  "numberLabel": "Número",
  "stateLabel": "Estado",
  "addAccessModalTitle": "Agregar Acceso",
  "addPhoneModalTitle": "Agregar Teléfono",
  "addAddressModalTitle": "Agregar Dirección",
  "streetAddressLabel": "Dirección",
  "zipCodeLabel": "Código Postal",
  "countyLabel": "Condado",
  "cityLabel": "Ciudad",
  "referenceLabel": "Referencia",
  "generalInformationTitle": "Información General",
  "notificationsTitle": "Notificaciones",
  "addressesTitle": "Direcciones",
  "phonesTitle": "Teléfonos",
  "emailsTitle": "Correos Electrónicos",
  "licensesTitle": "Licencias",
  "accountsTitle": "Cuentas",
  "relationsTitle": "Relaciones",
  "accessTitle": "Acceso",
  "permissionsTitle": "Permisos",
  "noInformationAvailableMessage": "No hay información disponible",
  "passwordRecoveryButton": "recuperación de contraseña",
  "emailLabel": "Correo Electrónico",
  "loadingText": "cargando",
  "titleCompanyAlert": "Compañía de títulos",
  "deleteAddressTitle": "Eliminar Dirección",
  "deleteAddressMessage": "¿Está seguro de eliminar {{address}}?",
  "deleteNumberTitle": "Eliminar Número",
  "deleteNumberMessage": "¿Está seguro de eliminar {{number}}?",
  "deleteEmailTitle": "Eliminar Correo",
  "deleteEmailMessage": "¿Está seguro de eliminar {{email}}?",
  "deleteLicenseTitle": "Eliminar Licencia",
  "deleteLicenseMessage": "¿Está seguro de eliminar {{license}}?",
  "deleteAccountTitle": "Eliminar Cuenta",
  "deleteAccountMessage": "¿Está seguro de eliminar {{account}} del banco {{bank}}?",
  "deleteAssociationTitle": "Eliminar Asociación",
  "deleteAssociationParentMessage": "¿Está seguro de eliminar la asociación {{kind}} en {{name}}?",
  "deleteAssociationSubordinateMessage": "¿Está seguro de eliminar la asociación {{name}} como {{kind}}?",
  "deleteAccessTitle": "Eliminar Acceso",
  "deleteAccessMessage": "¿Está seguro de eliminar el acceso por correo electrónico?",
  "grid-view": "Vista de tarjetas",
  "list-view": "Vista de lista",
  "add-organization": "Agregar Organización",
  "add-person": "Agregar Persona",
  "searching": "Buscando contactos…",
  "no-results": "Ningún contacto coincide con \"{{text}}\"",
  "search-error": "No se pudieron cargar los contactos. Inténtelo de nuevo.",
  "saving": "Guardando…",
  "relation-on": "En {{name}}",
  "relation-as": "Como {{kind}}",
  "ai-usage-title": "Uso de IA",
  "ai-usage-details": "Detalles de uso de IA",
  "reset-ai-counters": "Reiniciar contadores",
  "reset-ai-counters-success": "Contadores de IA reiniciados"
}
